import { validateLibraryURL } from './validateLibraryURL';
export const REGISTRY_LIBRARY_PREFIX_DEPRECATED = 'components-registry-library-';
export const SHORT_REGISTRY_LIBRARY_PREFIX = '_rb-';
export const URL_NAMESPACE_SEPARATOR = '~';
export const getComponentsLibrariesFromURL = (url, prefix = SHORT_REGISTRY_LIBRARY_PREFIX) => {
    if (!url || typeof URLSearchParams === 'undefined') {
        return [];
    }
    const search = url.split('?').pop();
    if (!search) {
        return [];
    }
    const libraries = [];
    const params = new URLSearchParams(search);
    params.forEach((value, key) => {
        if (key.startsWith(REGISTRY_LIBRARY_PREFIX_DEPRECATED) ||
            key.startsWith(prefix)) {
            const withDeprecatedPrefix = key.includes(REGISTRY_LIBRARY_PREFIX_DEPRECATED);
            const artifactId = key
                .split(withDeprecatedPrefix ? REGISTRY_LIBRARY_PREFIX_DEPRECATED : prefix)
                .pop();
            const [libraryUrl, namespace] = value.split(URL_NAMESPACE_SEPARATOR);
            if (!validateLibraryURL(libraryUrl)) {
                return;
            }
            if (artifactId) {
                libraries.push({
                    url: libraryUrl,
                    namespace,
                });
            }
        }
    });
    return libraries;
};
//# sourceMappingURL=getComponentsLibrariesFromURL.js.map